module.exports = __webpack_public_path__ + "img/cgr__sans_un_bruit.7a331575.jpg";